import { render, staticRenderFns } from "./RegistrationDialog.vue?vue&type=template&id=1e6c9ce1&scoped=true&"
import script from "./RegistrationDialog.vue?vue&type=script&lang=js&"
export * from "./RegistrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDialog.vue?vue&type=style&index=0&id=1e6c9ce1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6c9ce1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6c9ce1')) {
      api.createRecord('1e6c9ce1', component.options)
    } else {
      api.reload('1e6c9ce1', component.options)
    }
    module.hot.accept("./RegistrationDialog.vue?vue&type=template&id=1e6c9ce1&scoped=true&", function () {
      api.rerender('1e6c9ce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lcd/views/LCD/modal/RegistrationDialog.vue"
export default component.exports